import { useRoutes } from 'react-router-dom';
import authRoutes from './authRoutes';
import mainRoutes from './mainRoutes';
import adminRoutes from './adminRoutes';
import installerRoutes from './installerRoutes';
import errorRoutes from './errorRoutes';

export default function Router() {
  return useRoutes([authRoutes, mainRoutes, adminRoutes, installerRoutes, errorRoutes]);
}
